import { IContractChargeDatesRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisContractChargeDatesRepository from './implementations/VectisContractChargeDatesRepository';

let instance: IContractChargeDatesRepository | null = null;

export default function makeContractChargeDatesRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisContractChargeDatesRepository(httpProvider);
  }

  return instance;
}
